'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z' });

var BatteryAlert = function BatteryAlert(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

BatteryAlert = (0, _pure2.default)(BatteryAlert);
BatteryAlert.muiName = 'SvgIcon';

exports.default = BatteryAlert;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/BatteryAlert.js
// module id = 2155
// module chunks = 0